<template>
  <div id="materialCategory">
    <div class="commonContainer">
      <div class="tableContainer">
        <el-card class="box-card">
          <div class="tableBox">
            <div class="orangeIcon">
              <i class="el-icon-s-order"></i>
            </div>
            <el-button class="addBtn" type="primary" icon="el-icon-plus" @click="createCategory()">{{ $t('add') }}</el-button>
          </div>
          <div style="margin-top: 20px">
            <el-table
              :data="tableData"
              style="width: 100%"
              v-loading="tableLoading"
            >
              <el-table-column
                fixed
                prop="name"
                :label="$t('materialCategory.name')"
              >
              </el-table-column>
              <el-table-column
                prop="sort"
                :label="$t('materialCategory.sort')">
              </el-table-column>
              <el-table-column
                :label="$t('operation')"
                width="120">
                <template slot-scope="scope">
                  <el-button @click="editCategory(scope.row)" type="text" size="small">{{ $t('edit') }}</el-button>
                  <el-button @click="deleteCategory(scope.row.id)" type="text" size="small">{{ $t('delete') }}</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagingBox">
              <el-pagination
                background
                @current-change="currentChange"
                :current-page="tableConfig.current"
                layout="total, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <el-dialog
      :title="isEdit ? $t('materialCategory.createCategory') : $t('materialCategory.editCategory')"
      :visible.sync="EditDialogVisible"
      width="40%"
      center
    >
      <el-form
        :model="categoryForm"
        ref="categoryForm"
        label-width="100px"
        class=""
      >
        <el-form-item :label="$t('materialCategory.name')" prop="categoryName">
          <el-input :placeholder="$t('materialCategory.enterCategoryName')" v-model="categoryForm.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('materialCategory.sort')" prop="sort" >
          <el-input-number v-model="categoryForm.sort" :min="1"></el-input-number>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitMaterialCategory">{{ $t('save') }}</el-button>
        <el-button type="primary" @click="EditDialogVisible = false">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'User',
  components: {
  },
  data: function () {
    return {
      tableData: [
        {
          name: 'OOTD素材',
          sort: 1,
          id: 1
        },
        {
          name: '品牌素材',
          sort: 2,
          id: 2
        },
        {
          name: '#拍力学模板',
          sort: 3,
          id: 3
        }
      ],
      tableLoading: false,
      isEdit: false,
      categoryForm: {
      },
      initCategoryForm: {
        name: '', // 名称
        sort: '' // 排序
      },
      EditDialogVisible: false,
      total: 0,
      tableConfig: {
        size: 10, // 每页数量
        current: 1 // 当前页码
      },
    }
  },
  mounted () {
  },
  methods: {
    editCategory: function(row) {
      this.isEdit = true
      this.EditDialogVisible = true
      this.categoryForm = _.cloneDeep(row)
    },
    deleteCategory: function() {
      // todo: 删除分类
    },
    createCategory: function() {
      this.isEdit = false
      this.EditDialogVisible = true
      this.categoryForm = _.cloneDeep(this.initCategoryForm)
    },
    submitMaterialCategory: function() {
      // todo: 保存素材分类
    },
    onSearch: async function (resetPage) {
      if (resetPage) {
        this.tableConfig.current = 1
      }
      this.tableLoading = true
      let res = await window.instance.post(window.surveyUrl + '/account/list', _.assign(this.filterForm, this.tableConfig))
      res = res.data
      if (res.code === 200) {
        const list = res.data.list
        this.total = res.data.total
        this.tableData = list
      }
      this.tableLoading = false
    },
    currentChange: function (index) {
      // 分页
      this.tableConfig.current = index
      this.onSearch(false)
    },
  }
}
</script>

<style scoped lang="sass">
#materialCategory
  .roleName
    color: #ff6801
    margin-left: 32px
    margin-bottom: 20px
  .roleCode
    margin-left: 32px
    margin-bottom: 14px
    label
      padding: 5px 0
  .addBtn
    position: absolute
    top: 0
    right: 0
</style>



// WEBPACK FOOTER //
// src/pages/wo/materialCategory.vue